'use client'

import { useContext } from 'react'
import { RecaptchaContext } from '@/components/recaptcha-provider'

export function useRecaptcha() {
  const context = useContext(RecaptchaContext)
  if (!context) {
    // This should not happen if RecaptchaProvider is correctly placed in layout.tsx
    throw new Error('useRecaptcha must be used within a RecaptchaProvider')
  }
  return context
}
